import React from 'react';
import { Order } from 'src/components/Table/types';

export enum Columns {
  FullName = 'fullName',
  Email = 'email',
  CreditorNumber = 'creditorNumber',
  BusinessUnit = 'businessUnit',
  Roles = 'roles',
  Status = 'status',
  Link = 'link',
}

export type Row = {
  cells: {
    [Columns.FullName]: React.ReactElement;
    [Columns.Email]: React.ReactElement;
    [Columns.CreditorNumber]: React.ReactElement;
    [Columns.BusinessUnit]: React.ReactElement;
    [Columns.Roles]: React.ReactElement;
    [Columns.Status]: React.ReactElement;
  };
  link: string;
};

export type HeadCell = {
  id: Columns;
  label: string;
  order: Order;
};
